// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__iuQnK","title":"Info_title__2fCEX","links":"Info_links__LkZz5","link":"Info_link__1USH3","logo":"Info_logo__WN6Pc"};